import { StringKeys } from '@/resources/strings/StringKeys';
import COLORS from '@/resources/style/Themes';
import { Lock } from '@mui/icons-material';
import { Box, Container, Typography } from '@mui/material';
import { t } from 'i18next';

const UnauthorizedBanner = () => {
  return (
    <Box
      role="alert"
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.13)',
        backdropFilter: 'blur(2px)',
        zIndex: 1000,
      }}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '75%',
          maxWidth: '500px',
          textAlign: 'center',
        }}
      >
        <Lock
          sx={{
            width: '100px',
            height: '100px',
            color: COLORS.SAFEGUARD_BLUE,
            marginBottom: '20px',
          }}
        />
        <Box
          sx={{
            color: COLORS.SAFEGUARD_BLUE,
            padding: '15px',
            borderRadius: '8px',
          }}
        >
          <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 500 }}>
            {t(
              StringKeys.YOU_MUST_BE_AN_AUTHORIZED_USER_TO_ACCESS_THIS_FEATURE,
            )}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default UnauthorizedBanner;
